export class PaginacionModel
{
	constructor() { }

	public RegistrosPorPagina: number = 0;
	public CatidadDeRegistros: number = 0;
	public PaginaActual: number = 0;
	public PaginaAnterior: number = 0;
	public PaginaSiguiente: number = 0;
	public PaginasTotales: number = 0;

	public CargarDatos(objeto: IPaginacion): void {
		this.RegistrosPorPagina = objeto.RegistrosPorPagina;
		this.CatidadDeRegistros = objeto.CatidadDeRegistros;
		this.PaginaActual = objeto.PaginaActual;
		this.PaginaAnterior = objeto.PaginaAnterior;
		this.PaginaSiguiente = objeto.PaginaSiguiente;
		this.PaginasTotales = objeto.PaginasTotales;
	}
}

export interface IPaginacion
{
	RegistrosPorPagina: number;
	CatidadDeRegistros: number;
	PaginaActual: number;
	PaginasTotales: number;
	PaginaSiguiente: number;
	PaginaAnterior: number;
}